import * as yup from 'yup';

export const requiredDateSchema: yup.SchemaOf<Date> = yup.date().required();

export const transformDecimal = (_: unknown, value: string) => {
    if (value.includes('.')) {
        return null;
    }
    return +value.replace(/,/, '.');
};

export const transformOptionalNumber = (v: string) => (v === '' || Number.isNaN(v) ? undefined : v);
